var borders_default = {
  "borderT": "XByp-",
  "borderB": "EE01j",
  "borderL": "_0ktYL",
  "borderR": "_4na7W"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
